import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { markHostStyles } from './utils/styleIsolation';
const root = createRoot(document.getElementById('root'));
// Mark all existing styles as belonging to the host app
// This prevents them from being scoped when remote apps load
markHostStyles();
// Normalize: strip trailing slashes so BrowserRouter and path logic work consistently
// If placeholder was not replaced (local dev without Docker), fall back to '/'
let rawBasePath = process.env.REACT_APP_BASE_PATH || '/';
if (rawBasePath === 'REACT_APP_BASE_PATH_VALUE') {
    rawBasePath = '/';
}
const basePath = rawBasePath === '/' ? '/' : rawBasePath.replace(/\/+$/, '');
root.render(_jsx(BrowserRouter, { basename: basePath, children: _jsx(App, {}) }));
